(() => {
  const desktopQuery = window.matchMedia('(min-width: 1181px) and (hover: hover) and (pointer: fine)');
  const closeDelay = 180;

  const closeMenu = (details) => {
    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
  };

  const openMenu = (details) => {
    document.querySelectorAll('.poshtik-header details.mega-menu[open]').forEach((item) => {
      if (item !== details) closeMenu(item);
    });
    details.setAttribute('open', '');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'true');
  };

  const enhanceHeader = (scope = document) => {
    scope.querySelectorAll('.poshtik-header header-menu > details.mega-menu').forEach((details) => {
      if (details.dataset.poshtikHoverReady === 'true') return;
      details.dataset.poshtikHoverReady = 'true';
      let closeTimer;

      details.addEventListener('pointerenter', () => {
        if (!desktopQuery.matches) return;
        window.clearTimeout(closeTimer);
        openMenu(details);
      });

      details.addEventListener('pointerleave', () => {
        if (!desktopQuery.matches) return;
        closeTimer = window.setTimeout(() => closeMenu(details), closeDelay);
      });

      details.addEventListener('focusin', () => {
        if (desktopQuery.matches) openMenu(details);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => enhanceHeader(), { once: true });
  } else {
    enhanceHeader();
  }

  document.addEventListener('shopify:section:load', (event) => enhanceHeader(event.target));
})();
